// Ephemeral execution runs a connector's auth and reference actions against
// credentials that were typed into a form but never saved (GUNDI-5562). Only
// the connectors listed here are cleared for it; every other technology keeps
// the behaviour it had before — `gundi:reference` fields stay free text in
// creation flows, and Test Connection stays disabled until the integration is
// saved.
//
// Keyed by the integration type's `value` (the slug), like
// TYPES_WITH_REQUIRED_BASE_URL. Both spellings are listed because the slug the
// EarthRanger runner registers has been seen as each; the rest of the portal
// keys on "earth_ranger". Trim this once the deployed slug is settled — a
// whitelist that misses the real one turns the feature off silently.
export const TYPES_WITH_EPHEMERAL_EXECUTION = [
  'earth_ranger',
  'earthranger',
  'skylight',
];

export const isEphemeralExecutionEnabled = (typeValue?: string): boolean =>
  !!typeValue && TYPES_WITH_EPHEMERAL_EXECUTION.includes(typeValue);
